import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { SideLayoutComponent } from './side-layout/side-layout.component';
import { WidgetsLayoutComponent } from './widgets-layout/widgets-layout.component';
import { WindAtmosphereComponent } from './wind-atmosphere/wind-atmosphere.component';
import { HydrographyComponent } from './hydrography/hydrography.component';
import { WavesComponent } from './waves/waves.component';
import { MapDialogComponent } from './map-dialog/map-dialog.component';
import { AboutDialogComponent } from './about-dialog/about-dialog.component';
import { WindInfoComponent } from './wind-atmosphere/wind-info/wind-info.component';
import { HydrographyInfoComponent } from './hydrography/hydrography-info/hydrography-info.component';
import { WavesInfoComponent } from './waves/waves-info/waves-info.component';

const routes: Routes = [
  { path: '', component: MainComponent },
  { path: 'ondas', component: MainComponent, data: { blockToShow: 'waves' } },
  {
    path: 'hidrografia',
    component: MainComponent,
    data: { blockToShow: 'hydrography' },
  },
  {
    path: 'meteorologia',
    component: MainComponent,
    data: { blockToShow: 'windAtmosphere' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {
  static components = [
    MainComponent,
    SideLayoutComponent,
    WidgetsLayoutComponent,
    WindAtmosphereComponent,
    HydrographyComponent,
    WavesComponent,
    MapDialogComponent,
    AboutDialogComponent,
    WindInfoComponent,
    WavesInfoComponent,
    HydrographyInfoComponent,
  ];
}
